import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import { A11y, Navigation } from "swiper/modules"
// Swiper CSS comes from application.bootstrap.scss (swiper-bundle.min); importing
// it here makes esbuild emit its own application.css, clobbering the sass bundle.

// The collection child-category thumb strip (collection/_child_nav.html.erb).
// slidesPerView: "auto" so tiles keep the fixed width CSS gives them —
// the strip holds anywhere from 3 to 20+ categories and they must all look
// the same size. watchOverflow (default) locks the arrows away when the
// whole set already fits, and centerInsufficientSlides centers that short
// set the way the old margin-auto track did.
export default class extends Controller {
  connect() {
    this.swiper = new Swiper(this.element.querySelector(".swiper"), {
      modules: [A11y, Navigation],
      slidesPerView: "auto",
      slidesPerGroupAuto: true,
      centerInsufficientSlides: true,
      spaceBetween: 8,
      grabCursor: true,

      navigation: {
        nextEl: this.element.querySelector(".swiper-button-next"),
        prevEl: this.element.querySelector(".swiper-button-prev"),
      },

      a11y: {
        slideRole: "listitem",
        prevSlideMessage: "Previous categories",
        nextSlideMessage: "More categories",
      },
    })
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy()
      this.swiper = null
    }
  }
}
